import React, { useState, useRef } from "react";
import Tooltip from "./Tooltip"; 
import twoDay from "../images/twoDayStats.png"

const buttonLabels = [
  "Shockwave", "Morale", "Meteors", "Missile", "Mines", "Vengeance",
  "Freeze", "Decoy", "Buff", "Possess", "Heal", "Medusa",
  "Push", "Recover", "Necromancy", "Clone", "Black Hole", "Champion"
];
  const suffixes = [
      "", "k", "m", "b", "t", "A", "B", "C", "D", "E", "F", "G",
      "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S",
      "T", "U", "V", "W", "X", "Y", "Z", "AA", "AB", "AC", "AD", "AE",
      "AF", "AG", "AH", "AI", "AJ", "AK", "AL", "AM", "AN", "AO", "AP", "AQ", 
      "AR", "AS", "AT", "AU", "AV", "AW", "AX", "AY", "AZ", "BA", "BB", "BC", 
      "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BK", "BL", "BM", "BN", "BO", 
      "BP", "BQ", "BR", "BS", "BT", "BU", "BV", "BW", "BX", "BY", "BZ", "CA",
      "CB", "CC", "CD", "CE", "CF", "CG", "CH", "CI", "CJ", "CK", "CL", "CM", 
      "CN", "CO", "CP", "CQ", "CR", "CS", "CT", "CU", "CV", "CW", "CX", "CY", 
      "CZ", "DA", "DB", "DC", "DD", "DE", "DF", "DG", "DH", "DI", "DJ", "DK", 
      "DL", "DM", "DN", "DO", "DP", "DQ", "DR", "DS", "DT", "DU", "DV", "DW", 
      "DX", "DY", "DZ", "EA", "EB", "EC", "ED", "EE", "EF", "EG", "EH", "EI", 
      "EJ", "EK", "EL", "EM", "EN", "EO", "EP", "EQ", "ER", "ES", "ET", "EU", 
      "EV", "EW", "EX", "EY", "EZ"
    ];

export default function CustomCalculatorCard2() {

function formatLargeNumber(num, precision = 3, t = false ) {
    
    if (num === 0) return "0";
    if (num < 1000 && !t) return num.toPrecision(precision);
  
    const tier = Math.floor(Math.log10(Math.abs(num)) / 3);
    const suffix = suffixes[tier] || `e${tier * 3}`;
    const scaled = num / Math.pow(10, tier * 3);
    if (!t) {
      return scaled.toPrecision(precision) + suffix;
    }
    return [scaled.toPrecision(precision), tier]; 
  }

const [gearLevels, setGearLevels] = useState({
  weapon: { legend: null, epic: null, rare: null, common: null },
  armor: { legend: null, epic: null, rare: null, common: null },
  helmet: { legend: null, epic: null, rare: null, common: null },
  ring: { legend: null, epic: null, rare: null, common: null },
  neck: { legend: null, epic: null, rare: null, common: null }
});

  const [attkRunes, setAttkRunes] = useState(null);
  const [healthRunes, setHealthRunes] = useState(null);
  const [baseRunes, setBaseRunes] = useState(null);

  const [attkRuneError, setAttkRuneError] = useState("");
  const [healthRuneError, setHealthRuneError] = useState("");
  const [baseRuneError, setBaseRuneError] = useState("");

  const [gearErrors, setGearErrors] = useState(["", "", "", "", ""]);

  const [theoretical, setTheoretical] = useState(false);

  const [result, setResult] = useState(null);
  const [stars, setStars] = useState(Array(18).fill(0));
  const [showTooltip, setShowTooltip] = useState(false);
  const infoRef = useRef(null);
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });

  const rarities = ["legend", "epic", "rare", "common"];
  const gearTypes = ["weapon", "armor", "helmet", "ring", "neck"];
  const handleMouseEnter = () => {
    if (infoRef.current) {
      const rect = infoRef.current.getBoundingClientRect();
      setTooltipPos({ x: rect.left + rect.width / 2, y: rect.bottom });
    }
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };
  function validateGear(levels){
    const lvls = levels.split(',').map(item => item.trim());
    if(lvls.length > 5){
        return "Need to input up to 5 levels for gear";
    }
    for(let i = 0; i< lvls.length; i++){
        const num = Number(lvls[i]);
        if ((!Number.isInteger(num)|| num < 0 || num > 50) && !theoretical){
          return "Gear must be a whole number between 0 and 50";
        }
        else if ((!Number.isInteger(num)|| num < 0 || num > 100)){
          return "Gear must be a whole number between 0 and 100";
        }
    }
  return true;
    }
  function validateRunes(nums, val=13){
    const num = Number(nums);
    const valued = theoretical? val*2 : val; 
    if (!Number.isInteger(num)|| num < 0 || num > valued){
            return `These runes must be a whole number between 0 and ${valued}`;
        }
    return true;
  }
function parseRunes(inputStr) {
  if (!inputStr) {
    // null, undefined, or empty string → treat as 5 zeros
    return Array(5).fill(0);
  }
  const parts = inputStr.split(',');
  if (parts.length === 1) {
    // Only one number, replicate it 5 times
    return Array(5).fill(parts[0]);
  }
  return parts;
}
function roundTo(n, decimals) {
  return Number(Math.round(n + "e" + decimals) + "e-" + decimals);
}
  function calculateAttackGear(nums){
    //1.25**5 * 1.5**5 * 1.8**5 * 2.49**5
    const leg = parseRunes(nums.legend);
    const legAttk =  leg.reduce((product, val) => product * (val === 0 ? 1 : ((val - 1) * 0.03 + 1.02)), 1);
    const ep = parseRunes(nums.epic); 
    const epAttk =  ep.reduce((product, val) => product * (val === 0 ? 1 : Number((val - 1) * 0.016 + 1.016).toFixed(2)), 1);
    const rar = parseRunes(nums.rare); 
    const rarAttk =  rar.reduce((product, val) => product * (val*0.5/50 + 1), 1);
    const com = parseRunes(nums.common); 
    const comAttk =  com.reduce((product, val) => product * (val*0.25/50 + 1), 1);
    return legAttk*epAttk*rarAttk*comAttk;
  }
  function calculateGear(nums){
    const leg = parseRunes(nums.legend);
    const legGear =  leg.reduce((product, val) => product * (val/100 + 1), 1);
    const ep = parseRunes(nums.epic); 
    const epGear =  ep.reduce((product, val) => product * roundTo(Number(val*0.375/50 + 1),3), 1);
    const rar = parseRunes(nums.rare); 
    const rarGear =  rar.reduce((product, val) => product * (val/200 + 1), 1);
    const com = parseRunes(nums.common); 
    const comGear =  com.reduce((product, val) => product * roundTo(Number(val/400 + 1),3), 1);
    return legGear*epGear*rarGear*comGear;
  }
  const handleCalculate = () => {
    
    let hasErrors = false; 
    const newErrors = {};
    gearTypes.forEach(type => {
    newErrors[type] = {};
    rarities.forEach(rarity => {
      const input = gearLevels[type]?.[rarity] ?? "";
      const validationResult = validateGear(input);

      if (validationResult !== true) {
        newErrors[type][rarity] = validationResult;
        hasErrors = true;
      } else {
        newErrors[type][rarity] = "";
      }
    });
  });

  setGearErrors(newErrors);
  const attkResult = validateRunes(attkRunes ?? "");
  if (attkResult !== true) {
    setAttkRuneError(attkResult);
    hasErrors = true;
  } else {
    setAttkRuneError("");
  }

  const healthResult = validateRunes(healthRunes ?? "");
  if (healthResult !== true) {
    setHealthRuneError(healthResult);
    hasErrors = true;
  } else {
    setHealthRuneError("");
  }

  const baseResult = validateRunes(baseRunes ?? "", 14);
  if (baseResult !== true) {
    setBaseRuneError(baseResult);
    hasErrors = true;
  } else {
    setBaseRuneError("");
  }
  if (hasErrors) return; // Stop if any errors
    const attackVals = stars.slice(0, 6);
    const healthVals = stars.slice(6, 12);
    const baseVals = stars.slice(12, 18);
    const totalSkillAttack = attackVals.reduce((product, val) => product * (val/10 + 1), 1);
    const totalSkillHealth = healthVals.reduce((product, val) => product * (val/10 + 1), 1);
    const totalSkillBase = baseVals.reduce((product, val) => product * (val/10 + 1), 1);

    const totalGearAttack = calculateAttackGear(gearLevels.weapon);
    const totalGearHealth = calculateGear(gearLevels.helmet, 2) * calculateGear(gearLevels.armor, 2);
    const totalGearBase = calculateGear(gearLevels.ring) * calculateGear(gearLevels.neck);

    const totalRuneAttack = Math.pow(1.52, attkRunes);
    const totalRuneHealth = Math.pow(1.52, healthRunes);
    const totalRuneBase = Math.pow(1.5, baseRunes);

    const totalAttack = (totalGearAttack * totalSkillAttack * totalRuneAttack);
    const totalHealth = (totalGearHealth * totalSkillHealth * totalRuneHealth);
    const totalBase = (totalGearBase * totalSkillBase * totalRuneBase);

    console.log(totalGearHealth, totalHealth);
    const formattedStats = {
      rows: [
          {name: "Your Skill Stats", val: `Attack: ${formatLargeNumber(totalSkillAttack)}\nHealth: ${formatLargeNumber(totalSkillHealth)}\nBase: ${formatLargeNumber(totalSkillBase)}`},
          {name: "Your Rune Stats", val: `Attack: ${formatLargeNumber(totalRuneAttack)}\nHealth: ${formatLargeNumber(totalRuneHealth)}\nBase: ${formatLargeNumber(totalRuneBase)}`},
          {name: "Your Gear Stats", val: `Attack: ${formatLargeNumber(totalGearAttack)}\nHealth: ${formatLargeNumber(totalGearHealth)}\nBase: ${formatLargeNumber(totalGearBase)}`},
          {name: "Your Total Stats:", val: `Attack: ${formatLargeNumber(totalAttack)}\nHealth: ${formatLargeNumber(totalHealth)}\nBase: ${formatLargeNumber(totalBase)}` }
      ]
};
    setResult(formattedStats);
  };

  const handleReset = () => {
    setResult(null);
    setStars(Array(18).fill(0));
    setGearLevels({
  weapon: { legend: null, epic: null, rare: null, common: null },
  armor: { legend: null, epic: null, rare: null, common: null },
  helmet: { legend: null, epic: null, rare: null, common: null },
  ring: { legend: null, epic: null, rare: null, common: null },
  neck: { legend: null, epic: null, rare: null, common: null }
});

 setAttkRunes(null);
 setHealthRunes(null);
  setBaseRunes(null);

  setAttkRuneError("");
  setHealthRuneError("");
  setBaseRuneError("");
  setTheoretical(false);

  setGearErrors(["", "", "", "", ""]);
  };

  const handleMax = () => {

    const stars = theoretical? 6 : 3; 
    const glvls = theoretical? '100' : '50';
    const runedNorm = theoretical? 26 : 13;
    const runeBased = theoretical? 28 : 14;
    setResult(null);

    setStars(Array(18).fill(stars));
    setGearLevels({
  weapon: { legend: glvls, epic: glvls, rare: glvls, common: glvls },
  armor: { legend: glvls, epic: glvls, rare: glvls, common: glvls },
  helmet: { legend: glvls, epic: glvls, rare: glvls, common: glvls },
  ring: { legend: glvls, epic: glvls, rare: glvls, common: glvls },
  neck: { legend: glvls, epic: glvls, rare: glvls, common: glvls }
});

 setAttkRunes(runedNorm);
 setHealthRunes(runedNorm);
  setBaseRunes(runeBased);

  setAttkRuneError("");
  setHealthRuneError("");
  setBaseRuneError("");

  setGearErrors(["", "", "", "", ""]);
  };
  const handleStarClick = (index) => {
    setStars((prev) => {
      const newStars = [...prev];
      const repeat = theoretical? 7 : 4;
      newStars[index] = (newStars[index] + 1) % repeat; // 0 → 1 → 2 → 3 → 0
      return newStars;
    });
  };

  const renderResult = (result) => {
    if (!result || !Array.isArray(result.rows) || result.rows.length === 0) return null;

    const isRowLayout = result.rows.length > 3;
    const layoutClass = isRowLayout
      ? "flex flex-col flex-wrap gap-3"
      : "flex flex-row flex-wrap gap-3";

    return (
      <div className="card bg-white shadow-md rounded-xl p-4 mt-4 max-w-xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Result</h2>
        <div className={layoutClass}>
          {result.rows.map((row, index) => (
            <div
              key={index}
              className="bg-gray-100 p-3 rounded-lg flex flex-col items-start flex-2 min-w-[150px]"
            >
              <div className="text-sm text-gray-500">{row.name}</div>
              <div className="text-lg font-semibold whitespace-pre-line">{row.val}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="relative bg-white/60 card p-6 border rounded-md shadow-md backdrop-blur-sm transition">
      {/* Header */}
      <div className="flex items-center justify-center mb-4 relative">
        <h2 className="text-2xl mr-2">2 Day Event Calculator Version &lt; 1.56 </h2>
        <div
          ref={infoRef}
          className="text-sm text-blue-500 cursor-pointer"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={() => {
            if (window.innerWidth <= 768) {
              handleMouseEnter();
              setTimeout(() => setShowTooltip(false), 3000);
            }
          }}
        >
          ℹ️
        </div>

        {showTooltip && (
          <Tooltip
            position={{
              x: tooltipPos.x,
              y: tooltipPos.y,
              onMouseEnter: handleMouseEnter,
              onMouseLeave: handleMouseLeave
            }}
          >
            {"A calculator to determine your stats for the 2 day race. (still testing, there could be rouding errors). Note, it only does full skill ascensions. You can input only a single number for an average amount in that gear rarity. Ensure you put in 5 numbers seperated by a comma, inputting 3 or 4 numbers only assumes level 0 for that equipment"}
            {twoDay && (
              <img
                alt={`Stats for 2 day race example`}
                src={twoDay}
                className="max-w-[200px] w-full rounded-lg mt-2"
              />
            )}
          </Tooltip>
        )}
      </div>

      {/* Star Button Grid */}
<div className="flex flex-col lg:flex-row justify-between gap-6 w-full">
    <div className="flex-1">
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
            {gearTypes.map((type) => (
  <div key={type}>
    <h3 className="font-semibold capitalize mb-2">{type}</h3>
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
      {rarities.map((rarity) => (
        <div key={`${type}-${rarity}`} className="flex flex-col">
          <label
            className="capitalize text-sm mb-1"
            htmlFor={`${type}-${rarity}`}
          >
            {rarity}
          </label>
          <input
            id={`${type}-${rarity}`}
            type="text"
            placeholder="e.g. 1,2,3,4,5"
            className={`border p-2 rounded-md w-full max-w-[128px] ${
              gearErrors[type]?.[rarity] ? "border-red-500" : ""
            }`}
            value={gearLevels[type]?.[rarity] ?? ""}
            onChange={(e) => {
              const value = e.target.value;
              setGearLevels((prev) => ({
                ...prev,
                [type]: {
                  ...prev[type],
                  [rarity]: value,
                },
              }));
            }}
          />
          {gearErrors[type]?.[rarity] && (
            <p className="text-red-500 text-xs mt-1">
              {gearErrors[type][rarity]}
            </p>
          )}
        </div>
      ))}
    </div>
  </div>
))}
  <h3 className="font-semibold capitalize mt-6 mb-2">Runes</h3>
<div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-2">
  <div >
    <label htmlFor="AttkRune" className="text-sm mb-1">Attack Runes:</label>
    <input
      type="text"
      id="AttkRune"
      name="AttkRune"
      placeholder="e.g. 5"
      className={`border p-2 rounded-md w-full max-w-[128px] ${
      attkRuneError ? "border-red-500" : ""
    }`}
    value={attkRunes ?? ""}
    onChange={(e) => setAttkRunes(e.target.value)}
  />
  {attkRuneError && (
    <p className="text-red-500 text-xs mt-1">{attkRuneError}</p>
  )}
</div>
  <div >
    <label htmlFor="HealthRune" className="text-sm mb-1">Health Runes:</label>
    <input
      type="text"
      id="HealthRune"
      name="HealthRune"
      placeholder="e.g. 4"
      className={`border p-2 rounded-md w-full max-w-[128px] ${
      healthRuneError ? "border-red-500" : ""
    }`}
    value={healthRunes ?? ""}
    onChange={(e) => setHealthRunes(e.target.value)}
  />
  {healthRuneError && (
    <p className="text-red-500 text-xs mt-1">{healthRuneError}</p>
  )}
</div>
  <div>
    <label htmlFor="BaseRune" className="text-sm mb-1">Base Runes:</label>
    <input
      type="text"
      id="BaseRune"
      name="BaseRune"
      placeholder="e.g. 8"
      className={`border p-2 rounded-md w-full max-w-[128px] ${
      baseRuneError ? "border-red-500" : ""
    }`}
    value={baseRunes ?? ""}
    onChange={(e) => setBaseRunes(e.target.value)}
  />
  {baseRuneError && (
    <p className="text-red-500 text-xs mt-1">{baseRuneError}</p>
  )}
</div>
</div>

    </div>
</div>
        <div className="inline-grid grid-cols-3 lg:grid-cols-6 gap-3 p-2 mb-6 max-w-[1200px]">
    {buttonLabels.map((label, i) => (
      <button
        key={i}
        onClick={() => handleStarClick(i)}
        className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-blue-500 text-white flex flex-col items-center justify-center hover:bg-blue-600 transition"
      >
        <span className="text-[10px] sm:text-xs font-semibold text-center leading-tight">
          {label}
        </span>
        <span className="flex flex-wrap w-fit justify-center gap-2 text-yellow-300 text-xs sm:text-sm mt-1">
          {Array.from({ length: stars[i] }).map((_, index) => (
    <span key={index}>⭐</span>
  ))}
        </span>
      </button>
    ))}
  </div>

</div>
      {/* Action Buttons */}
      <div className="flex flex-wrap gap-4 mb-6">
  <button
    className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-xl"
    onClick={handleCalculate}
  >
    Calculate
  </button>
  <button
    className="bg-gray-400 hover:bg-gray-500 text-white font-semibold py-2 px-4 rounded-xl"
    onClick={handleReset}
  >
    Reset
  </button>
  <button
    className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-xl"
    onClick={handleMax}
  >
    Max
  </button>
  <label 
    htmlFor="doubled" 
    className="flex items-center gap-2 bg-gray-400 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-xl cursor-pointer select-none"
  >
    <input 
      type="checkbox" 
      id="doubled" 
      name="doubled"
      checked={theoretical}
      className="form-checkbox h-5 w-5 text-blue-500 rounded-md focus:ring-2 focus:ring-offset-1 focus:ring-white"
      onChange={(e) => setTheoretical(e.target.checked)}
    />
    Double Max?
  </label>
</div>

      {/* Results */}
      {renderResult(result)}
    </div>
  );
}


